import { cn } from "~/lib/utils";

function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0]!.charAt(0).toUpperCase();
  return (parts[0]!.charAt(0) + parts[parts.length - 1]!.charAt(0)).toUpperCase();
}

export interface AvatarProps {
  readonly name: string;
  readonly src?: string | null;
  readonly className?: string;
}

/**
 * Shared avatar primitive: square-rounded initials chip, or the image when a
 * src is given. Replaces the ad-hoc initial-circle divs scattered across the
 * sidebar / CMMD center surfaces.
 */
export function Avatar({ name, src, className }: AvatarProps) {
  const base = cn(
    "inline-flex size-6 shrink-0 items-center justify-center overflow-hidden rounded-full",
    "bg-muted text-[10px] font-medium text-muted-foreground",
    className,
  );
  if (src) {
    return <img src={src} alt={name} className={cn(base, "object-cover")} />;
  }
  return (
    <span className={base} aria-label={name}>
      {initials(name)}
    </span>
  );
}
